export enum ClickNames {
    Android = 'google_play_click',
    Ios = 'app_store_click',
}

export enum Views {
    WebSiteView = "website_view",
}